module.exports = __webpack_public_path__ + "img/solo-en-mexico-solo-en-dominos.08109a36.png";